const { get } = require('../../utils/retriever');
const { MatchMediaBreakpoint } = require('match-media-breakpoint');
const config = require('../../../config.json');
const removeParams = [
    'pageId',
    'shareSectionTitle',
    'a11yShareBtnText',
    'a11yCloseText',
    'a11yMinimizeText',
    'a11yMaximizeText',
    'a11ySpinnerText',
    'a11yAttentionText',
    'defaultErrorMessage'
];

module.exports = class {
    onInput(input) {
        const showDialog = get(input, 'open', false);
        const model = get(input, 'model', {});
        const breakpoints = config.breakpoints;

        const queryParams = Object.keys(model).filter((e) =>
            removeParams.indexOf(e) < 0
        ).map(e => `${e}=${model[e]}`).join('&');

        const matchMediaBreakpoint = new MatchMediaBreakpoint({
            breakpoints,
            onBreakpointChange: (currentBreakpoint) => {
                this.state.currentBreakpoint = currentBreakpoint;
            }
        });

        this.state = {
            open: showDialog,
            currentBreakpoint: matchMediaBreakpoint.value,
            queryParams
        };
    }

    resetDialog() {
        this.emit('close');
    }
};
